import type { en } from "./en";

// Somali translations. Missing keys fall back to English via i18next.
export const so: typeof en = {
  common: {
    home: "Bogga hore",
    no_scores: "Weli dhibco ma jiraan",
    points_count_one: "{{count}} dhibic",
    points_count_other: "{{count}} dhibco",
    questions_count_one: "{{count}} su'aal",
    questions_count_other: "{{count}} su'aalood",
  },
  home: {
    placeholder: "Koodhka ciyaarta",
    enter: "Gal",
    error_invalid_code:
      "Geli koodhka ciyaarta ee 6-xaraf ah ee macallinkaagu ku siiyay.",
    footer: "Ka bilow Binogi Buzz alaabta Binogi.com.",
    language_label: "Luqadda",
  },
  errors: {
    generic: "Wax baa khaldamay. Fadlan isku day mar kale.",
    stale_client: "Boggaagu waa duugoobay — fadlan cusboonaysii.",
    session_not_found: "Kal-fadhigan lama helin.",
    session_not_open: "Kal-fadhigan wuu dhammaaday.",
    session_not_active: "Su'aashan ama kal-fadhigan horey ayay u dhammaadeen.",
    not_teacher: "Macallinka oo keliya ayaa samayn kara taas.",
    already_answered: "Horey ayaad uga jawaabtay su'aashan.",
    wrong_question_index: "Su'aashan weli ma bilaabmin.",
    name_taken: "Magacaas waa la qaatay. Isku day mid kale.",
    character_busy: "Hadda laguma siin karin jilaa — fadlan isku day mar kale.",
  },
  host: {
    input: {
      heading: "Bilow Buzz",
      lead:
        "Geli koodhka casharka Binogi ee ardaydaadu baranayaan. Waxaan soo dejin doonnaa su'aalaha oo aan abuuri doonnaa kal-fadhi aad sabbuuradda ku tusi karto.",
      lesson_code_label: "Koodhka casharka",
      placeholder_code: "BIH750",
      load_button: "Soo deji casharka",
      try_hint: "Tijaabi:",
      error_invalid_code: "Geli koodhka casharka Binogi, tusaale BIH750.",
      error_not_found: "Lama helin cashar leh koodhka {{code}}.",
      error_unreachable: "Lama gaari karin server-ka casharrada. Hubi xidhiidhkaaga oo isku day mar kale.",
      error_no_questions: "Casharka {{code}} ma laha su'aalo Buzz isticmaali karo.",
      error_no_level_questions: "Casharka {{code}} ma laha su'aalo heerka la doortay ah.",
    },
    loading: "Casharka ayaa la soo dejinayaa…",
    placeholder_title: "Bilow Binogi Buzz",
    tab_details: "Faahfaahin",
    tab_questions: "Su'aalo",
    settings: "Goobaha",
    number_of_students: "Tirada ardayda",
    fewer_students: "Arday ka yar",
    more_students: "Arday ka badan",
    player_names: "Magacyada ciyaartoyga",
    player_anonymous: "Magac la'aan",
    player_self_chosen: "Ardayda ayaa doorta",
    language: "Luqadda",
    language_teacher: "Macallinka ayaa doorta",
    language_students: "Ardayda ayaa doorta",
    time_per_question: "Wakhtiga su'aashii",
    time_option: "{{seconds}} il",
    start_button: "Bilow kal-fadhiga",
    start_disabled: "Dooro cabbirka fasalka si aad u bilowdo",
    creating: "Kal-fadhiga waa la abuurayaa…",
    error_no_questions: "Hayso ugu yaraan hal su'aal ka hor inta aanad bilaabin.",
    error_create_failed: "Lama abuuri karin kal-fadhiga",
    error_load_failed: "Casharka lama soo dejin karin",
    no_session: "Ma jiro kal-fadhi socda.",
    back_to_review: "Ku noqo su'aalaha",
    errors: {
      dismiss: "Xidh",
      refresh: "Cusboonaysii",
      attach_failed: "Shaashaddan kuma xidhmi karin macallin ahaan.",
      unreachable: "Lama gaari karin server-ka. Cusboonaysii bogga si aad mar kale isugu daydo.",
      no_token: "Tab-kan mar dambe ma maamuli karo kediska. Ka fur Buzz casharkaaga si aad u bilowdo kal-fadhi cusub.",
      taken_over: "Kediskan hadda waxaa laga maamulayaa shaashad kale.",
      stale_question: "Buzz ayaa la cusboonaysiiyay intii kediskan socday, sidaas darteed shaashaddan ma sii wadi karto. Dib u soo deji bogga si aad kediska uga sii wadato meesha fasalku joogo.",
      question_moved_on: "Kediska horey ayuu u sii socday, sidaas darteed shaashaddan way ka dambaysaa. Dib u soo deji bogga si aad kediska uga sii wadato meesha fasalku joogo.",
    },
    entry: {
      opening: "Muuqaalka macallinka waa la furayaa…",
      token_title: "Linkigan macallinka lama furi karo",
      token_body: "Linkiga waxaa ka maqan furaha macallinka ama wuu dhacay. Ka fur Buzz casharkaaga si aad u abuurto kal-fadhi cusub.",
      not_found_title: "Kal-fadhiga lama helin",
      not_found_body: "Kal-fadhigan kediska hadda ma jiro. Samee mid cusub si aad u sii wadato.",
      back: "Ku noqo bilowga",
    },
    questions: {
      drag_aria: "Jiid si aad u kala hagaajiso",
      remove_aria: "Tirtir su'aasha",
      empty: "Ma jiraan su'aalo ku hadhay kal-fadhigan.",
      add: "Ku dar",
      add_aria: "Ku dar su'aal: {{text}}",
      add_all: "Ku dar dhammaan",
      add_all_n: "Ku dar dhammaan {{count}} su'aalood",
      more_one: "{{count}} su'aal oo kale casharkan ku jirta",
      more_other: "{{count}} su'aalood oo kale casharkan ku jira",
      level_easy: "Fudud",
      level_medium: "Dhexdhexaad",
      level_hard: "Adag",
      multi: "Doorasho badan",
    },
    lobby: {
      go_to: "U tag <strong>buzz.binogi.com</strong> oo geli:",
      or_qr: "…ama iskaaneey koodhka QR",
      students_joined_of: "{{joined}} arday oo ka mid ah {{expected}} ayaa ku biiray",
      students_joined_one: "{{count}} arday ayaa ku biiray",
      students_joined_other: "{{count}} arday ayaa ku biiray",
      waiting: "Sugaya in ardaydu ku biiraan…",
      start_game: "Bilow ciyaarta",
      connected: "Waa la xidhiidhay",
      connecting: "Waa la xidhiidhayaa…",
      copy_link: "Koobi linkiga",
      copy_link_copied: "Waa la koobiyey!",
    },
    question: {
      header: "Su'aasha {{index}} ee {{total}}",
      level: "Heerka {{level}}",
      none: "Ma jirto su'aal firfircoon.",
      answered: "La jawaabay",
      top_n: "{{count}} ee ugu sarreeya",
      answers_heading: "Jawaabaha",
      end_question: "Soo gabagabee su'aasha",
      next_question: "Su'aasha xigta",
      see_results: "Eeg natiijada kama dambaysta ah",
    },
    results: {
      heading: "Natiijada kama dambaysta ah",
      all_players: "Dhammaan ciyaartoyga",
      end_session: "Soo gabagabee kal-fadhiga",
      new_session: "Kal-fadhi cusub",
      none: "Kal-fadhigan ma laha ciyaartoy.",
    },
  },
  join: {
    code_label: "Koodhka ciyaarta",
    name_label: "Magacaaga",
    name_placeholder: "Qor magacaaga",
    join_button: "Ku biir",
    joining: "Waa la ku biirayaa…",
    checking: "Waa la hubinayaa…",
    character_hint:
      "Waxaad heli doontaa magac jilaa Binogi ah oo xiiso leh markaad ku biirto.",
    error_not_found:
      "Koodhkani weli ma aha kal-fadhi toos ah. La xaqiiji macallinkaaga.",
    error_lookup_failed: "Lama heli karin kal-fadhiga",
    error_code_required: "Geli koodhka 6-xaraf ah.",
    error_name_required: "Qor magacaaga.",
  },
  play: {
    superseded: "Waxaad ku xiran tahay tab kale — xir si aad halkan ugu sii ciyaarto.",
    back_to_join: "Ku noqo ku biirista",
    no_round: "Ma jiro xog wareeg.",
    not_joined: "Kuma aadan biirin kal-fadhi.",
    no_question: "Ma jirto su'aal firfircoon.",
    keep_awake_hint: "Taabo shaashadda si ay u sii shidnaato",
    waiting: {
      you_are: "Waxaad tahay",
      get_ready_named: "Isu diyaari, {{name}}!",
      get_ready: "Isu diyaari quiz-ka!",
      in_room_label: "Ardayda qolka ku jirta",
      in_room_one: "{{count}} arday ayaa qolka jooga",
      in_room_other: "{{count}} arday ayaa qolka jooga",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Waan jawaabay!",
      times_up: "Wakhtigii waa dhammaaday",
      submit: "Dir",
      submit_n: "Dir {{count}} jawaabood",
    },
    between: {
      correct: "Sax!",
      wrong: "Ku dhowaad!",
      times_up: "Wakhtigii waa dhammaaday",
      points_gained: "+{{count}} dhibic",
      your_score: "Dhibcahaaga",
      your_rank: "Kaalintaada {{rank}}",
      top_n: "{{count}} ee ugu sarreeya",
      waiting_next: "Sugaya su'aasha xigta…",
    },
    finished: {
      heading: "Mahadsanid inaad ciyaartay Binogi Buzz!",
      your_final_rank: "Kaalintaada kama dambaysta ah",
      top_n: "{{count}} ee ugu sarreeya",
      none: "Ma jiraan natiijooyin la muujiyo.",
    },
  },
  characters: {
    heading: "Jilayaasha Binogi",
    lead:
      "{{count}} arday ayaa hela jilaa markay ku biiraan, sida nidaamkan ah.",
  },
};
